import client from '@/api/client.js';
//import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getCommonPartsFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getCommonPartsFromFilter', input: { filter: filter } }
            var response = await client().get(`${store.state.apiRouteRoot}CommonParts/Filtered`, { params: filter, signal: cancelationToken, meta: meta });
            return response?.data;
        },

         async getCommonPartsFromModel(modelId) {
            var meta = { clientApiMethod: 'getCommonPartsFromModel', input: { modelId } }
            var response = await client().get(`${store.state.apiRouteRoot}CommonParts/${modelId}`, { meta: meta });
            return response?.data;
        },

        async addCommonPartsToModel(modelId, selectionFilter) {
            var meta = {
                clientApiMethod: 'addCommonPartsToModel',
                input: { modelId, selectionFilter },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().post(`${store.state.apiRouteRoot}CommonParts/${modelId}`, selectionFilter, { meta: meta });
          
            return response?.data;
        },

        async changeCommonPartPosition(modelId, articleId, position) { 
            var meta = {
                clientApiMethod: 'changeCommonPartPosition',
                input: {modelId, articleId, position },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().put(`${store.state.apiRouteRoot}CommonParts/${modelId}/Move` +
                `?articleId=${articleId}&position=${position}`, null, { meta: meta });
            return response?.data;
        },

        async removeCommonPartFromModel(modelId, articleId) {
            var meta = {
                clientApiMethod: 'removeCommonPartFromModel',
                input: { modelId, articleId },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().delete(`${store.state.apiRouteRoot}CommonParts/${modelId}/Article/${articleId}`, null, { meta: meta });
            return response?.data;
        },
    }
}